"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("react"),
  t = require("prop-types"),
  n = require("./link-8b1ebef7.js"),
  a = require("./foundations/Icon/icons/social/Youtube.js"),
  i = require("./taggedTemplateLiteral-97b463ad.js"),
  l = require("styled-components"),
  r = require("polished/lib/helpers/rem"),
  d = require("./grid-965d799c.js"),
  o = require("./typography-fb2881fe.js");
function u(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var g,
  s,
  c,
  f,
  m,
  p,
  h,
  b,
  k,
  L,
  y,
  T = u(e),
  v = u(t),
  j = u(l),
  q = u(r),
  x = j["default"].div(g || (g = i._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme,
      n = t.mediumUp();
    return l.css(s || (s = i._taggedTemplateLiteral(["\n      display: flex;\n      position: relative;\n      width: 100%;\n      min-height: ", ";\n      margin-bottom: ", ";\n      transition: ", ";\n      background-color: ", ";\n      flex-direction: column;\n      justify-content: center;\n      &:hover {\n        box-shadow: ", ";\n        text-decoration: none;\n        cursor: pointer;\n      }\n    "])), n ? q["default"](100) : q["default"](90), q["default"](6), t.effects.shadows.transition, t.colors.neutral.grayLight30, t.effects.shadows.hover);
  }),
  _ = j["default"](d.Row)(c || (c = i._taggedTemplateLiteral(["\n  min-height: ", ";\n  padding: ", " 0;\n  align-items: center;\n"])), q["default"](70), q["default"](20)),
  E = j["default"](d.Col)(f || (f = i._taggedTemplateLiteral(["\n  display: flex;\n  height: ", ";\n  padding: 0;\n  align-items: center;\n  justify-content: center;\n  .nmx-icon {\n    width: 100%;\n    height: 100%;\n  }\n"])), q["default"](70)),
  w = j["default"](d.Col)(m || (m = i._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme.mediumUp();
    return l.css(p || (p = i._taggedTemplateLiteral(["\n      display: flex;\n      height: ", ";\n      padding-left: ", ";\n      align-items: center;\n      justify-content: center;\n    "])), q["default"](80), t ? q["default"](20) : q["default"](15));
  }),
  I = j["default"].div(h || (h = i._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.backgroundImage;
    return l.css(b || (b = i._taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    background-image: url('", "');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n  "])), t);
  }),
  O = j["default"](d.Col)(k || (k = i._taggedTemplateLiteral(["\n  display: flex;\n  padding-left: 0;\n  align-items: center;\n"]))),
  U = j["default"](o.TypographyComponent)(L || (L = i._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme;
    return l.css(y || (y = i._taggedTemplateLiteral(["\n    margin-top: ", ";\n    margin-bottom: 0;\n    padding-right: ", ";\n    padding-bottom: 0;\n    color: ", ";\n  "])), q["default"](-2), q["default"](30), t.colors.blue.blueLight10);
  }),
  C = function C(e) {
    var t = e.children,
      a = e.className,
      i = e.iconObject,
      l = e.imageUrl,
      r = e.imageVariant,
      d = e.isInternalPdf,
      o = e.isOutgoingLink,
      u = e.linkAriaLabel,
      g = e.linkId,
      s = e.linkUrl;
    return T["default"].createElement(x, {
      className: a
    }, T["default"].createElement(n.LinkComponent, {
      id: g,
      ariaLabel: u,
      isInternalPdf: d,
      isOutgoingLink: o,
      linkUrl: s,
      variant: "primaryDeemphasize"
    }, T["default"].createElement(_, null, "icon" === r && T["default"].createElement(E, {
      xsmall: 4,
      large: 3
    }, T["default"].createElement(i, null)), "image" === r && T["default"].createElement(w, {
      xsmall: 4
    }, T["default"].createElement(I, {
      id: "".concat(g, "-background-image-container"),
      backgroundImage: l
    })), T["default"].createElement(O, {
      xsmall: 8
    }, T["default"].createElement(U, {
      weight: 500
    }, t, " ")))));
  };
C.propTypes = {
  children: v["default"].node.isRequired,
  className: v["default"].string,
  imageVariant: v["default"].oneOf(["icon", "image"]),
  iconObject: v["default"].any,
  imageUrl: v["default"].any,
  isInternalPdf: v["default"].bool,
  isOutgoingLink: v["default"].bool,
  linkAriaLabel: v["default"].any,
  linkId: v["default"].string.isRequired,
  linkProps: v["default"].shape(n.linkPropTypes),
  linkUrl: v["default"].string.isRequired
}, C.defaultProps = {
  iconObject: a,
  imageVariant: "icon"
}, exports.DocumentLinkComponent = C;